import lodash from 'lodash';

const install = app => {
  app.config.globalProperties.$_ = lodash;
  app.provide('lodash', lodash);
};

export { install as default };
